module.exports = __webpack_public_path__ + "static/img/13areaB_2.2ef901e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/13areaB_2.png
// module id = 1109
// module chunks = 1